import React, { useState } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import brand from '../lib/brand';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    const result = await login(values.email, values.password);
    setLoading(false);
    if (result.success) {
      navigate('/');
    } else {
      message.error(result.message);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f0f2f5' }}>
      <Card title={<div style={{ textAlign: 'center' }}><img src="/logo.png" alt={brand.name} style={{ height: 60, margin: '0 auto 8px' }} /><div>{brand.name} Merchant</div></div>} style={{ width: 400 }}>
        <Form onFinish={onFinish} layout="vertical">
          <Form.Item name="email" rules={[{ required: true, message: 'Имэйл оруулна уу' }]}>
            <Input prefix={<MailOutlined />} placeholder="Имэйл" size="large" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: 'Нууц үг оруулна уу' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="Нууц үг" size="large" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block size="large">
              Нэвтрэх
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
